import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { Modal } from "antd"
import { useContext, useEffect, useState } from "react"
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import columns from "../../screens/control/grid_columns/commentary_grid_columns"
import { displayMessage } from "../../services/helper";

export const CommentaryModal = props => {

    const { setShowLoading, mobile_mode } = useContext(GeneralContext)

    const [commentarys, setCommentarys] = useState([])


    useEffect(() => {
        loadCommentarys()
    }, [])

    const gridRef = useGridApiRef()

    const loadCommentarys = async () => {
        try {
            setShowLoading(true)
            gridRef.current.setSelectionModel([])
            setCommentarys(props?.currenComments)
        }
        finally {
            setShowLoading(false)
        }
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('COMMENTS')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={mobile_mode ? '90%' : '60%'}
            height={'80%'}
            style={{ position: 'relative' }}
            bodyStyle={{ height: mobile_mode ? '100vh' : '70vh', display: 'flex', flexDirection: 'column' }}

        >
            <div style={{
                height: '100%',
                display: 'flex',
            }} >
                <DataGridPro
                    rows={commentarys}
                    apiRef={gridRef}
                    style={{ flex: 1, display: 'flex' }}
                    density={"comfortable"}
                    columns={columns(mobile_mode)}
                    pagination
                    pageSize={100}
                    disableMultipleSelection
                    disableSelectionOnClick
                />
            </div>
        </Modal>
    )
}